export function createField(type, defaultValue) {
    return { type, defaultValue };
}

export function getEntityTypes(entity) {
    let et = {};
    Object.keys(entity).forEach((key) => {
        et[key] = entity[key].type;
    });
    return et;
};

export function getEntityDefaults(entity){
    let ed = {};
    Object.keys(entity).forEach((key) => {
        ed[key] = entity[key].defaultValue;
    });
    return ed;
};

export function mapEntity(baseEntity, entity){
    return Object.keys(baseEntity).reduce(
        (acc, key) => ({ ...acc, [key]: entity[key] || baseEntity[key].defaultValue }),
        {},
    );
};